import { MenuLateral } from '@/components/shared/MenuLateral';
import { ComposicaoCOEX } from '@/pages/Extensao/ComposicaoCOEX';

import { Route, Routes } from 'react-router-dom';


const AcademicoExtensaoRoutes = () => {
    return (
        <div className='flex'>
            <MenuLateral
                title='Extensão - Acadêmico'
                menuType='feagri-extensao-academic'
            />

            <div className='pl-10'>
                <Routes>
                    <Route path='/comissao/composicao-coex' element={<ComposicaoCOEX />} />
                </Routes>
            </div>

        </div>
    );
}

export { AcademicoExtensaoRoutes };